module.exports = __webpack_public_path__ + "images/drawings/bud_status_1.ab9b073671198b8a2b90603b8e0d03d5.png";